import { SUITE_BRAND } from "@/config/suite";

/**
 * PageHeader — header standard per tutte le pagine.
 *
 * Struttura Design System Gruppo Impresa Suite:
 *   [SUITE brand ─ maiuscoletto piccolo]
 *   [Titolo pagina · font-serif · compatto]
 *   [Sottotitolo · testo secondario]
 *
 * Ottimizzato per densità verticale: dashboard direzionale visibile
 * senza scroll su 1920×1080 @ 100% zoom.
 */
export const PageHeader = ({
  title,
  subtitle,
  actions,
  testId,
  showSuiteBrand = true,
  superTitle,
}) => (
  <header
    data-testid={testId}
    className="mb-3 flex flex-wrap items-end justify-between gap-3 border-b border-stone-200 pb-2.5"
  >
    <div className="min-w-0">
      {showSuiteBrand && (
        <div
          data-testid="page-supertitle"
          className="text-[9px] font-bold uppercase tracking-[0.28em] text-primary"
        >
          {superTitle || SUITE_BRAND.productName}
        </div>
      )}
      <h1
        data-testid="page-title"
        className="font-serif text-2xl font-semibold leading-tight tracking-tight text-stone-900"
      >
        {title}
      </h1>
      {subtitle && (
        <p className="mt-0.5 text-[12px] leading-snug text-stone-500">
          {subtitle}
        </p>
      )}
    </div>
    {actions && (
      <div className="flex flex-wrap items-center justify-end gap-2">
        {actions}
      </div>
    )}
  </header>
);
